import React from 'react';
import { useTranslation } from '../contexts/TranslationContext';

const Datenschutz = () => {
    const { t } = useTranslation();

    return (
        <div className="bg-white">
            {/* Hero Section - Mobile optimized */}
            <section className="relative min-h-[40vh] sm:h-[50vh] flex items-center justify-center bg-gradient-to-br from-primary-50 via-white to-accent-50 overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-r from-primary-900/10 via-transparent to-accent-900/10"></div>
                <div className="container-custom relative z-10 text-center pt-20 sm:pt-24 px-4">
                    <h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-neutral-950 mb-4 sm:mb-6 leading-tight">
                        {t('privacy.title')}
                    </h1>
                    <p className="text-base sm:text-xl md:text-2xl text-neutral-700 max-w-3xl mx-auto leading-relaxed">
                        {t('privacy.description')}
                    </p>
                </div>
            </section>

            {/* Content - Mobile optimized */}
            <section className="section-padding bg-neutral-50">
                <div className="container-custom">
                    <div className="max-w-4xl mx-auto bg-white rounded-xl sm:rounded-2xl shadow-md sm:shadow-lg border border-gray-100 p-5 sm:p-8 md:p-12">
                        <div className="space-y-8 sm:space-y-10">
                            {/* Data Controller */}
                            <section>
                                <h3 className="text-xl sm:text-2xl font-semibold text-neutral-950 mb-3 sm:mb-4">
                                    1. {t('privacy.dataController')}
                                </h3>
                                <div className="text-neutral-700 leading-relaxed whitespace-pre-line text-base sm:text-lg">
                                    {t('privacy.dataControllerText')}
                                </div>
                            </section>

                            {/* Data Processing */}
                            <section>
                                <h3 className="text-xl sm:text-2xl font-semibold text-neutral-950 mb-3 sm:mb-4">
                                    2. {t('privacy.dataProcessing')}
                                </h3>
                                <div className="text-neutral-700 leading-relaxed whitespace-pre-line text-base sm:text-lg">
                                    {t('privacy.dataProcessingText')}
                                </div>
                            </section>

                            {/* Data Types */}
                            <section>
                                <h3 className="text-xl sm:text-2xl font-semibold text-neutral-950 mb-3 sm:mb-4">
                                    3. {t('privacy.dataTypes')}
                                </h3>
                                <div className="text-neutral-700 leading-relaxed whitespace-pre-line text-base sm:text-lg">
                                    {t('privacy.dataTypesText')}
                                </div>
                            </section>

                            {/* Legal Basis */}
                            <section>
                                <h3 className="text-xl sm:text-2xl font-semibold text-neutral-950 mb-3 sm:mb-4">
                                    4. {t('privacy.legalBasis')}
                                </h3>
                                <div className="text-neutral-700 leading-relaxed whitespace-pre-line text-base sm:text-lg">
                                    {t('privacy.legalBasisText')}
                                </div>
                            </section>

                            {/* Data Sharing */}
                            <section>
                                <h3 className="text-xl sm:text-2xl font-semibold text-neutral-950 mb-3 sm:mb-4">
                                    5. {t('privacy.dataSharing')}
                                </h3>
                                <div className="text-neutral-700 leading-relaxed whitespace-pre-line text-base sm:text-lg">
                                    {t('privacy.dataSharingText')}
                                </div>
                            </section>

                            {/* Data Transfer */}
                            <section>
                                <h3 className="text-xl sm:text-2xl font-semibold text-neutral-950 mb-3 sm:mb-4">
                                    6. {t('privacy.dataTransfer')}
                                </h3>
                                <p className="text-neutral-700 leading-relaxed text-base sm:text-lg">
                                    {t('privacy.dataTransferText')}
                                </p>
                            </section>

                            {/* Data Retention */}
                            <section>
                                <h3 className="text-xl sm:text-2xl font-semibold text-neutral-950 mb-3 sm:mb-4">
                                    7. {t('privacy.dataRetention')}
                                </h3>
                                <div className="text-neutral-700 leading-relaxed whitespace-pre-line text-base sm:text-lg">
                                    {t('privacy.dataRetentionText')}
                                </div>
                            </section>

                            {/* Security */}
                            <section>
                                <h3 className="text-xl sm:text-2xl font-semibold text-neutral-950 mb-3 sm:mb-4">
                                    8. {t('privacy.security')}
                                </h3>
                                <div className="text-neutral-700 leading-relaxed whitespace-pre-line text-base sm:text-lg">
                                    {t('privacy.securityText')}
                                </div>
                            </section>

                            {/* Your Rights */}
                            <section>
                                <h3 className="text-xl sm:text-2xl font-semibold text-neutral-950 mb-3 sm:mb-4">
                                    9. {t('privacy.yourRights')}
                                </h3>
                                <div className="text-neutral-700 leading-relaxed whitespace-pre-line text-base sm:text-lg">
                                    {t('privacy.yourRightsText')}
                                </div>
                            </section>

                            {/* Cookies */}
                            <section>
                                <h3 className="text-xl sm:text-2xl font-semibold text-neutral-950 mb-3 sm:mb-4">
                                    10. {t('privacy.cookies')}
                                </h3>
                                <div className="text-neutral-700 leading-relaxed whitespace-pre-line text-base sm:text-lg">
                                    {t('privacy.cookiesText')}
                                </div>
                            </section>

                            {/* Automated Processing */}
                            <section>
                                <h3 className="text-xl sm:text-2xl font-semibold text-neutral-950 mb-3 sm:mb-4">
                                    11. {t('privacy.automated')}
                                </h3>
                                <p className="text-neutral-700 leading-relaxed text-base sm:text-lg">
                                    {t('privacy.automatedText')}
                                </p>
                            </section>

                            {/* Minors */}
                            <section>
                                <h3 className="text-xl sm:text-2xl font-semibold text-neutral-950 mb-3 sm:mb-4">
                                    12. {t('privacy.minors')}
                                </h3>
                                <p className="text-neutral-700 leading-relaxed text-base sm:text-lg">
                                    {t('privacy.minorsText')}
                                </p>
                            </section>

                            {/* Updates */}
                            <section>
                                <h3 className="text-xl sm:text-2xl font-semibold text-neutral-950 mb-3 sm:mb-4">
                                    13. {t('privacy.updates')}
                                </h3>
                                <p className="text-neutral-700 leading-relaxed text-base sm:text-lg">
                                    {t('privacy.updatesText')}
                                </p>
                            </section>

                            {/* Contact */}
                            <section>
                                <h3 className="text-xl sm:text-2xl font-semibold text-neutral-950 mb-3 sm:mb-4">
                                    14. {t('privacy.contact')}
                                </h3>
                                <div className="text-neutral-700 leading-relaxed whitespace-pre-line text-base sm:text-lg">
                                    {t('privacy.contactText')}
                                </div>
                            </section>

                            {/* Complaints */}
                            <section>
                                <h3 className="text-xl sm:text-2xl font-semibold text-neutral-950 mb-3 sm:mb-4">
                                    15. {t('privacy.complaints')}
                                </h3>
                                <div className="text-neutral-700 leading-relaxed whitespace-pre-line text-base sm:text-lg">
                                    {t('privacy.complaintsText')}
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Datenschutz;